export default "/images/ddcd1abc5eaf7bffe9307dd0bec3b648.jpg";